/**
 * 字段的校驗規則
 */
export const rulesJsonData = {
  personDataRules: {
    nameChineseX: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
            callback(new Error("請輸入中文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    nameChineseM: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
            callback(new Error("請輸入中文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    nameEnglishL: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/[a-zA-z]$/.test(value) == false) {
            callback(new Error("請輸入英文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    nameEnglishF: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/[a-zA-z]$/.test(value) == false) {
            callback(new Error("請輸入英文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    hkCardNo: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/^[A-Za-z]\d{6}[A-Za-z0-9]$/.test(value) == false) {
            callback(new Error("身份證號碼格式不正確"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    birthDate: [{
      required: true,
      trigger: 'change',
      message: " "
    }],
    gender: [{
      required: true,
      trigger: 'change',
      message: "請選擇性別"
    }],
    unitType: [{
      type: 'array',
      required: true,
      message: '請至少選擇一項入住單位類型',
      trigger: 'change'
    }],
    telephoneNo: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        min: 8,
        message: '請填寫頭 8 位数字',
        trigger: 'blur'
      }
    ]
  },
  personData2Rules: {
    nameChineseX: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
            callback(new Error("請輸入中文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    nameChineseM: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
            callback(new Error("請輸入中文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    nameEnglishL: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/[a-zA-z]$/.test(value) == false) {
            callback(new Error("請輸入英文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    nameEnglishF: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/[a-zA-z]$/.test(value) == false) {
            callback(new Error("請輸入英文"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    hkCardNo: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/^[A-Za-z]\d{6}[A-Za-z0-9]$/.test(value) == false) {
            callback(new Error("身份證號碼格式不正確"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    birthDate: [{
      required: true,
      trigger: 'change',
      message: " "
    }],
    gender: [{
      required: true,
      trigger: 'change',
      message: "請選擇性別"
    }],
    telephoneNo: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        min: 8,
        message: '請填寫頭 8 位数字',
        trigger: 'blur'
      }
    ],
    email: [{
        required: true,
        trigger: 'blur',
        message: " "
      },
      {
        validator: function (rule, value, callback) {
          if (/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(value) == false) {
            callback(new Error("請輸入正確郵箱格式"));
          } else {
            //校验通过
            callback();
          }
        },
        trigger: "blur"
      }
    ]
  },
  hleFormDataRules: {
    islands: [{
      required: true,
      trigger: 'change',
      message: " "
    }],
    areas: [{
      required: true,
      trigger: 'change',
      message: " "
    }],

    detailAddress: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    householdsNum: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    saleableArea: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    residenceType: [{
      required: true,
      trigger: 'change',
      message: "請選擇住所類型"
    }],
    education: [{
      required: true,
      trigger: 'change',
      message: " "
    }],
    industryOccupation: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    interestsSkills: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    communityDevelopment: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    independentUrgency: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    goalAchieve: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
    ph2Culture: [{
      required: true,
      trigger: 'blur',
      message: " "
    }],
  }
}



// WEBPACK FOOTER //
// ./src/utils/json/formRules.js